export default "__VITE_ASSET__BduVvaQl__"